import moment from "moment";
import * as yup from "yup";

export const ProjectsValidationSchema = yup.object({
  // General Informations
  name: yup.string().trim().required("Veuillez saisir le nom du projet"),
  summary: yup.string().trim().required("Veuillez saisir le résumé"),
  beneficiaryNumber: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir le numéro du beneficiaire"),
  locationCountry: yup.string().trim().required("Veuillez saisir le pays"),
  locationCity: yup.string().trim().required("Veuillez saisir la ville"),
  financialSupportRequest: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir la demande de financement"),
  startDate: yup.date().required("Veuillez saisir la date de début"),
  endDate: yup.date().required("Veuillez saisir la date de fin"),
  // step: yup.string().required("Veuillez saisir l'étape"),
  provisionalBudget: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir le budget prévisionnel"),
  useOfSupportRequest: yup.string().trim().required("Veuillez saisir l'utilité de la demande"),
  otherFinancialPartner: yup.string().trim().required("Veuillez saisir un autre partenaire financier"),
  comment: yup.string().trim().required("Veuillez saisir un commentaire"),
  // consultantInvolved: yup.string().trim().required("Veuillez saisir le consultant impliqué"),

   // SignatoryAgreement
   signatoryAgreementLastname: yup.string().trim().required("Veuillez saisir le nom"),
   signatoryAgreementFirstname: yup.string().trim().required("Veuillez saisir le prénom"),
   signatoryAgreementMobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone mobile"),
   signatoryAgreementEmail: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   qualityOfSignatory: yup.string().trim().required("Veuillez saisir la fonction"),
   // signatoryAgreementFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),
 
   // AdministrativeContact
   administrativeContactFirstname: yup.string().trim().required("Veuillez saisir le prénom"),
   administrativeContactLastname: yup.string().trim().required("Veuillez saisir le nom"),
   administrativeContactMobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone"),
   administrativeContactEmail: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   civility: yup.string().trim().required("Veuillez saisir la civilité"),
   // administrativeContactFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),
   administrativeContactFunction: yup.string().trim().required("Veuillez saisir la fonction"),
   region: yup.string().trim().required("Veuillez saisir la région"),
   city: yup.string().trim().required("Veuillez saisir la ville"),
   postalBox: yup.string().trim().required("Veuillez saisir la boite postale"),

   // OperationalContact
   operationalContactFirstname: yup.string().trim().required("Veuillez saisir le prénom"),
   operationalContactLastname: yup.string().trim().required("Veuillez saisir le nom"),
   function: yup.string().trim().required("Veuillez saisir la fonction"),
   regionOfContact: yup.string().trim().required("Veuillez saisir la région"),
   cityOfContact: yup.string().trim().required("Veuillez saisir la ville"),
   postalBoxOfContact: yup.string().trim().required("Veuillez saisir la boite postale"),
   streetAndNumber: yup.string().trim().required("Veuillez saisir la rue"),
   operationalContactMobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone"),
   operationalContactEmail: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   departmentOfContact: yup.string().trim().required("Veuillez saisir le département"),
   adresse: yup.string().trim().required("Veuillez saisir l'adresse"),
   // operationalContactFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),
   // districtOfContact: yup.string().trim().required("Veuillez saisir le district"),

   // StructureBankAccount
   accountOwner: yup.string().trim().required("Veuillez saisir le propriétaire du compte"),
   bankName: yup.string().trim().required("Veuillez saisir le nom de la banque"),
   bankAddress: yup.string().trim().required("Veuillez saisir l'adresse de la banque"),
   cityOfBank: yup.string().trim().required("Veuillez saisir la ville de la banque"),
   accountNumber: yup.string().trim().required("Veuillez saisir le numéro de compte"),
   poBox: yup.string().trim().required("Veuillez saisir la boite postale"),
   iban: yup.string().trim().required("Veuillez saisir le iban"),
   swiftCode: yup.string().trim().required("Veuillez saisir le swift code"),
 
   // Attachment
   applicationFile: yup.mixed().required("Veuillez fournir le fichier de projet"),
   statuts: yup.mixed().required("Veuillez fournir le fichier de statut projet"),
   // otherFile: yup.string().required("Veuillez saisir le nom du projet"),
   previousAnnualReport: yup.mixed().required("Veuillez fournir le précédent fichier de rapport annuel"),
   budget: yup.mixed().required("Veuillez fournir le fichier de budget"),
   chronogram: yup.mixed().required("Veuillez fournir le fichier chronogramme"),
});


export const generalInfosValidationSchema = yup.object({
  // General Informations
  name: yup.string().trim().required("Veuillez saisir le nom du projet"),
  summary: yup.string().trim().required("Veuillez saisir le résumé"),
  beneficiaryNumber: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir le numéro du beneficiaire"),
  locationCountry: yup.string().trim().required("Veuillez saisir le pays"),
  locationCity: yup.string().trim().required("Veuillez saisir la ville"),
  financialSupportRequest: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir la demande de financement"),
  startDate: yup.date().required("Veuillez saisir la date de début"),
  // step: yup.string().required("Veuillez saisir l'étape"),
  provisionalBudget: yup.number().min(0, "Doit être supérieur ou égal à 0").required("Veuillez saisir le budget prévisionnel"),
  useOfSupportRequest: yup.string().trim().required("Veuillez saisir l'utilité de la demande"),
  otherFinancialPartner: yup.string().trim().required("Veuillez saisir un autre partenaire financier"),
  comment: yup.string().trim().required("Veuillez saisir un commentaire"),
  // consultantInvolved: yup.string().trim().required("Veuillez saisir le consultant impliqué"),

  endDate: yup.date()
  .when(
   'startDate',
   (startDate, schema) => {
     if (startDate.length !== 0) {
       return startDate[0] !== undefined ? schema.min(startDate, "La date de fin doit être supérieur à celle de début...") : schema;
     }

     return schema;
   },)
   .required("Veuillez saisir la date de fin"),
});

export const signatoryAgreementValidationSchema = yup.object({
   // SignatoryAgreement
   lastname: yup.string().trim().required("Veuillez saisir le nom"),
   firstname: yup.string().trim().required("Veuillez saisir le prénom"),
   mobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone"),
   email: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   qualityOfSignatory: yup.string().trim().required("Veuillez saisir la fonction"),
   // signatoryAgreementFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),

});

export const administrativeContactValidationSchema = yup.object({
   // AdministrativeContact
   firstname: yup.string().trim().required("Veuillez saisir le prénom"),
   lastname: yup.string().trim().required("Veuillez saisir le nom"),
   mobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone"),
   email: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   civility: yup.string().trim().required("Veuillez saisir la civilité"),
   // administrativeContactFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),
   function: yup.string().trim().required("Veuillez saisir la fonction"),
   region: yup.string().trim().required("Veuillez saisir la région"),
   city: yup.string().trim().required("Veuillez saisir la ville"),
   postalBox: yup.string().trim().required("Veuillez saisir la boite postale"),
});

export const operationalContactValidationSchema = yup.object({
   // OperationalContact
   firstname: yup.string().trim().required("Veuillez saisir le prénom"),
   lastname: yup.string().trim().required("Veuillez saisir le nom"),
   function: yup.string().trim().required("Veuillez saisir la fonction"),
   regionOfContact: yup.string().trim().required("Veuillez saisir la région"),
   cityOfContact: yup.string().trim().required("Veuillez saisir la ville"),
   postalBoxOfContact: yup.string().trim().required("Veuillez saisir la boite postale"),
   streetAndNumber: yup.string().trim().required("Veuillez saisir la rue"),
   mobilePhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone"),
   email: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'email"),
   departmentOfContact: yup.string().trim().required("Veuillez saisir le département"),
   adresse: yup.string().trim().required("Veuillez saisir l'adresse"),
   // operationalContactFixPhone: yup.string().trim().required("Veuillez saisir le numéro de téléphone fixe"),
   // districtOfContact: yup.string().trim().required("Veuillez saisir le district"),

});

export const structureBankAccountValidationSchema = yup.object({
 
   // StructureBankAccount
   accountOwner: yup.string().trim().required("Veuillez saisir le propriétaire du compte"),
   bankName: yup.string().trim().required("Veuillez saisir le nom de la banque"),
   bankAddress: yup.string().trim().required("Veuillez saisir l'adresse de la banque"),
   cityOfBank: yup.string().trim().required("Veuillez saisir la ville de la banque"),
   accountNumber: yup.string().trim().required("Veuillez saisir le numéro de compte"),
   poBox: yup.string().trim().required("Veuillez saisir la boite postale"),
   iban: yup.string().trim().required("Veuillez saisir le iban"),
   swiftCode: yup.string().trim().required("Veuillez saisir le swift code"),

});

export const attachmentValidationSchema = yup.object({
  
   // Attachment
   applicationFile: yup.mixed().required("Veuillez fournir le fichier de projet") 
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 5409546; // 3245728;
      }
      return true;
   }),
   statuts: yup.mixed().required("Veuillez fournir le fichier de statut projet")
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 5409546; // 3245728;
      }
      return true;
   }),
   // otherFile: yup.string().required("Veuillez saisir le nom du projet"),
   previousAnnualReport: yup.mixed().required("Veuillez fournir le précédent fichier de rapport annuel")
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 5409546; // 3245728;
      }
      return true;
   }),
   budget: yup.mixed().required("Veuillez fournir le fichier de budget")
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 5409546; // 3245728;
      }
      return true;
   }),
   chronogram: yup.mixed().required("Veuillez fournir le fichier chronogramme")
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 5409546; // 3245728;
      }
      return true;
   }),
   /*otherFile: yup.mixed()
   .test('fileSize', 'La taille max de fichier est de 3Mo', value => {
      if (value) {
        let newFile = value as File;
        return newFile?.size <= 3245728;
      }
      return true;
   }),*/
   // otherFile1: yup.string().required("Veuillez choisir un autre fichier"),
   // otherFile2: yup.string().required("Veuillez choisir un autre fichier"),
   // otherFile3: yup.string().required("Veuillez choisir un autre fichier"),
   // otherFile4: yup.string().required("Veuillez choisir un autre fichier"),
});


export const projectsValidationSchema = yup.object({
  name: yup.string().trim().required("Veuillez saisir le nom du projet"),
  // holder: yup.mixed().required("Veuillez choisir le porteur du projet"),
  // initiator: yup.mixed().required("Veuillez choisir l'initiateur du projet"),
  // direction: yup.mixed().required("Veuillez saisir le nom du projet"),
  startDate: yup.date().required("Veuillez choisir la date de lancement souhaité"),
  // targetClient: yup.string().required("Veuillez indiquer la cible"),
  // sendToART: yup.boolean(),
  // origin: yup.string(),
  // goal: yup.string(),
  // reason: yup.string(),
  // description: yup.string(),
  // priority: yup.string().required("Veuillez choisir la priorité du projet"),
});
